import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions
} from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SharedComponentsModule } from './shared-components.module';
import { SharedControlsMaterialModule } from './material/shared-controls-material.module';

const modules = [
  CommonModule,
  SharedControlsMaterialModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  TranslatePipe,
  InfiniteScrollModule,
  ImageCropperComponent,
  PdfViewerModule,
  SharedComponentsModule
];

// Tooltips close as soon as the pointer leaves their field and never catch
// clicks, so they cannot cover an open select's options. The delays repeat
// Material's defaults, which this token replaces.
const TOOLTIP_DEFAULT_OPTIONS: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 1500,
  disableTooltipInteractivity: true
};

@NgModule({
  imports: modules,
  exports: modules,
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' }
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: TOOLTIP_DEFAULT_OPTIONS
    }
  ]
})
export class SharedModule {}
